import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-brown" }
const _hoisted_2 = { class: "text-2xl font-semibold mb-4" }
const _hoisted_3 = { class: "text-base leading-[20px]" }
const _hoisted_4 = { class: "text-base leading-[20px]" }
const _hoisted_5 = { class: "text-base leading-[20px] font-bold" }
const _hoisted_6 = { class: "list-disc space-y-1 pl-6" }
const _hoisted_7 = { class: "text-base leading-[20px]" }

import { useI18n } from "vue-i18n";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ICzinFAQ',
  setup(__props) {

const { tm } = useI18n();

const instruction = computed(
  () => tm("calculators.iczin.instruction") as unknown
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(instruction.value.first_title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(instruction.value.first_paragraph), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString(instruction.value.second_paragraph), 1),
    _createElementVNode("p", _hoisted_5, _toDisplayString(instruction.value.second_title), 1),
    _createElementVNode("ul", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instruction.value.list, (item, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: "text-base leading-[20px]"
        }, _toDisplayString(item), 1))
      }), 128))
    ]),
    _createElementVNode("p", _hoisted_7, _toDisplayString(instruction.value.third_paragraph), 1)
  ]))
}
}

})